import React from 'react';

export default function ItemSender({ senderId, domElementsRef }) {
  return (
    senderId && (
      <span ref={(ref) => (domElementsRef.current.id = ref)} className={'my-gift__filter-id'}>
        {senderId}
      </span>
    )
  );
}
